import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./TeamSelector.css";
import "../css/default.css";
import { Helmet } from "react-helmet";
import React, { useEffect } from "react";

export function TeamSelector() {
    useEffect(() => {
        window.scrollTo(0, 0)
        if (document.URL.endsWith("/team")) {
            document.getElementById("mod").classList.add("active")
        }
    }, [])

    const navigate = useNavigate();
    return (
        <>
        <Helmet>
        <script src="https://www.recaptcha.net/recaptcha/api.js" async defer></script>
        </Helmet>
        <div className="container-fluid">
            <div className="container" style={{minHeight: "70vh"}}>
                <img src="https://i.ibb.co/pbmTk4d/logo-For-Site.png" alt="Main Logo" className="mainLogo"></img>
                <nav className="nav nav-pills nav-justified formNav">
                    <NavLink id="mod" className="nav-link forms-bar" to="/team/moderators" end>Mods</NavLink>
                    <NavLink className="nav-link forms-bar" to="/team/artists">Artists</NavLink>
                </nav>

                <select className="form-select form-select-lg mb-3" id="select" onInput={() => changePage(navigate)} defaultValue="moderators">
                    <option value="moderators">Mods</option>
                    <option value="artists">Artists</option>
                </select>

                <Outlet />
                
            </div>
        </div>
        </>
    )
}

function changePage(navigate) {
    let toNav = document.getElementById("select").selectedOptions[0].value;
    navigate(`/team/${toNav}`);
}